import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { IUser } from 'interfaces/users'
import { AccessLevelEnum } from 'enum/accessLevel'
import ProfileModal from 'components/reusables/profileModal'
import { ProfilesWrapper } from './styled'

interface IProps {
  user: IUser
}

const AccessLevel = ({ user }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.users.table.headers.accessLevel'
  const [showDetail, setShowDetail] = useState(false)

  const Profiles = (
    <>
      <Tooltip
        getPopupContainer={() =>
          document.getElementById('lmsPage') as HTMLElement
        }
        title={t(`${prefix}.profiles.tooltip`)}
      >
        <ProfilesWrapper onClick={() => setShowDetail(true)}>
          {user.profiles.length}{' '}
          {user.profiles.length === 1
            ? t(`${prefix}.profiles.title.singular`)
            : t(`${prefix}.profiles.title.plural`)}
          <FontAwesomeIcon icon={faEye} />
        </ProfilesWrapper>
      </Tooltip>
      {showDetail && (
        <ProfileModal
          resourceId={user.id}
          resourceType="user_workspace"
          close={() => setShowDetail(false)}
        />
      )}
    </>
  )

  switch (user.accessLevel) {
    case AccessLevelEnum.AllCollaborators:
      return <>{t(`${prefix}.allCollaborators`)}</>
    case AccessLevelEnum.DirectTeam:
      return <>{t(`${prefix}.directTeam`)}</>
    case AccessLevelEnum.DirectTeamAndSpecificCollaborators:
      return (
        <>
          <div>{t(`${prefix}.directTeam`)}</div>
          {Profiles}
        </>
      )
    case AccessLevelEnum.SpecificCollaborators:
      return Profiles
  }
}

export default AccessLevel
